module.exports = __webpack_public_path__ + "static/media/cookie-card_FPO.62f2a9a6.png";